var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#008CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6453 25.0122H36.9078L35.0266 35.5341L55.5328 35.5653C65.6297 35.5653 68.6266 39.231 68.5297 45.3153C68.4859 48.4341 67.1266 53.7091 66.5516 55.4091C64.9984 59.9716 61.7984 65.1653 49.8047 65.1497L29.8734 65.1372L27.9922 75.6716H50.6703C58.6672 75.6716 62.0734 74.7372 65.6703 73.0778C73.6516 69.3966 78.4047 61.5122 80.3141 51.2216C83.1453 35.9091 79.6141 25.0122 59.6422 25.0122H59.6453Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3961 49.3687C50.1367 46.2905 50.3711 45.0562 50.3711 45.0562H27.1023C21.1523 45.0562 20.3023 48.9312 19.7367 51.2749C18.9961 54.3405 18.7617 55.5905 18.7617 55.5905H42.0336C47.9805 55.5905 48.8305 51.7155 49.3961 49.3687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/DASH.a8c13372ed0139ae3e8e2d4cbf01c277.svg";
export { ForwardRef as ReactComponent };